import React from 'react';
import createSubjectId from '@sprinx/pricing-core/createSubjectId';
export default function useCreateSubjectIdHandler() {
  return React.useCallback(function (productId, ruleCode) {
    return createSubjectId(productId, ruleCode);
  }, []);
}